var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation, useQuery } from '@apollo/client';
import { DialogTypes } from 'common/enums/components/dialog-types.enum';
import { SnackbarSeverity } from 'common/enums/components/snackbar-severity.enum';
import { DELETE_COMMUNITY_USER } from 'common/graphql/mutations/community/delete-community-user';
import { UPDATE_COMMUNITY_USER } from 'common/graphql/mutations/community/update-community-user';
import { COMMUNITY_PUBLIC_FIELDS } from 'common/graphql/queries/community/community-public-fields';
import { COMMUNITY_USERS_SEARCH } from 'common/graphql/queries/community/community-users-search';
import useDynamicMutation from 'common/hooks/useDynamicMutation';
import SearchBar from 'components/SearchBar/SearchBar';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openDialog, openSnackbar } from 'store/actions';
import CommunityParticipantsList from './CommunityParticipantsList';
import { communityParticipantsPerPage } from '../CommunityParticipationSettings';
var CommunityParticipants = function (_a) {
    var _b;
    var communityId = _a.communityId, areYouOwner = _a.areYouOwner;
    var t = useTranslation().t;
    var _c = useState(''), searchQuery = _c[0], setSearchQuery = _c[1];
    var _d = useQuery(COMMUNITY_USERS_SEARCH, {
        variables: {
            communityId: communityId,
            limit: communityParticipantsPerPage,
            offset: 0,
            searchQuery: searchQuery
        }
    }), communityUserData = _d.data, communityUserDataLoading = _d.loading, fetchMore = _d.fetchMore;
    var onSuccess = function () {
        dispatch(openSnackbar({
            message: t('Данные сохранены'),
            severity: SnackbarSeverity.SUCCESS
        }));
    };
    var onError = function (_a) {
        var errorDetails = _a.errorDetails, code = _a.code;
        dispatch(openSnackbar({
            message: errorDetails || code,
            severity: SnackbarSeverity.ERROR
        }));
    };
    var handleExecuteMutation = useDynamicMutation(function (userId) {
        return useMutation(DELETE_COMMUNITY_USER, {
            variables: {
                deleteCommunityUserData: {
                    communityId: communityId,
                    userId: userId
                }
            },
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: COMMUNITY_PUBLIC_FIELDS,
                    variables: {
                        id: communityId
                    }
                },
                COMMUNITY_USERS_SEARCH,
            ]
        });
    }, onSuccess, onError).handleExecuteMutation;
    var handleUpdateCommunityUserMutation = useDynamicMutation(function (data) {
        return useMutation(UPDATE_COMMUNITY_USER, {
            variables: {
                updateCommunityUserData: {
                    communityId: communityId,
                    userId: data === null || data === void 0 ? void 0 : data.userId,
                    isAdmin: data === null || data === void 0 ? void 0 : data.isAdmin,
                    isOwner: data === null || data === void 0 ? void 0 : data.isOwner
                }
            },
            refetchQueries: [COMMUNITY_USERS_SEARCH]
        });
    }, onSuccess, onError).handleExecuteMutation;
    var dispatch = useDispatch();
    var handleExpelUser = function (userId) {
        dispatch(openDialog({
            dialogType: DialogTypes.ExpelUserRequestDialog,
            dialogProps: { from: 'community', handleExpel: function () { return handleExecuteMutation(userId); } }
        }));
    };
    return (_jsxs("div", __assign({ className: "flex flex-col space-y-20 w-full" }, { children: [_jsx(SearchBar, { onSearch: function (value) {
                    setSearchQuery(value);
                } }, void 0), _jsx("div", __assign({ className: "flex xs:pb-16 md:pb-24" }, { children: _jsx(CommunityParticipantsList, { communityUsers: (communityUserData === null || communityUserData === void 0 ? void 0 : communityUserData.communityUsersSearch) || [], hasMore: ((_b = communityUserData === null || communityUserData === void 0 ? void 0 : communityUserData.communityUsersSearch) === null || _b === void 0 ? void 0 : _b.length) === communityParticipantsPerPage, isLoading: communityUserDataLoading, loadMore: function () {
                        fetchMore({
                            variables: {
                                offset: communityUserData === null || communityUserData === void 0 ? void 0 : communityUserData.communityUsersSearch.length
                            }
                        });
                    }, handleExpelUser: handleExpelUser, handleUpdateCommunityUser: handleUpdateCommunityUserMutation, areYouOwner: areYouOwner }, void 0) }), void 0)] }), void 0));
};
export default CommunityParticipants;
